"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chunk = void 0;
/**
 * Cuts up a list into chunks
 * @param list the list to chunk up
 * @param size the chunk size
 * @see also https://stackoverflow.com/questions/8495687/split-array-into-chunks
 */
function chunk(list, size) {
    return Array(Math.ceil(list.length / size))
        .fill(undefined)
        .map(function (_, index) { return index * size; })
        .map(function (begin) { return list.slice(begin, begin + size); });
}
exports.chunk = chunk;
//# sourceMappingURL=array.util.js.map